import cx from "classnames";
import PropTypes from "prop-types";
import { Component } from "react";

import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

export class DefaultLogoIcon extends Component {
  static defaultProps = {
    height: 32,
  };
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    dark: PropTypes.bool,
    fill: PropTypes.string,
  };

  render() {
    const { dark, height, width } = this.props;
    return (
      <img
        src="/app/assets/img/punsarn/harrt-logo.png"
        alt="harrt logo"
        height={height}
        width={width}
        data-testid="main-logo"
        className={cx("Icon", { "text-brand": !dark }, { "text-white": dark })}
      />
    );
  }
}

export default function LogoIcon(props) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
